"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicAuthContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
__exportStar(require("./models"), exports);
const c = (0, core_1.initContract)();
exports.publicAuthContract = c.router({
    register: {
        method: 'POST',
        path: '/register',
        body: models_1.ZRegisterUserSchema,
        responses: {
            200: zod_1.z.object({
                player: zod_1.z.object({
                    id: zod_1.z.string(),
                    emailAddress: zod_1.z.string(),
                    firstName: zod_1.z.string(),
                    lastName: zod_1.z.string(),
                    phoneNumber: zod_1.z.string().nullable(),
                    referralId: zod_1.z.string(),
                    status: zod_1.z.string(),
                    role: zod_1.z.string(),
                }),
                token: zod_1.z.string(),
            }),
            400: models_1.ZErrorResponseSchema,
            409: c.type(),
        },
        summary: 'Register a player with email, first name, last name and password',
    },
    requestPasswordReset: {
        method: 'POST',
        path: '/send-password-reset-token',
        body: models_1.ZRequestPasswordReset,
        responses: {
            200: utils_1.successSchema,
            400: c.type(),
        },
    },
    usePasswordResetToken: {
        method: 'POST',
        path: 'use-password-reset-token',
        body: models_1.ZUsePasswordReset,
        responses: {
            200: zod_1.z.object({ success: zod_1.z.boolean(), jwtToken: zod_1.z.string() }),
            400: c.type(),
        },
    },
    login: {
        method: 'POST',
        path: '/login',
        body: models_1.ZLoginUserSchema,
        responses: {
            200: zod_1.z.object({
                player: models_1.ZProfileResponseSchema,
                token: zod_1.z.string(),
            }),
            401: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Login a player with email and password',
    },
    loginWithGoogle: {
        method: 'POST',
        path: '/login/google',
        body: zod_1.z.object({
            accessToken: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                token: zod_1.z.string(),
                welcomeName: zod_1.z.string(),
                abtestVariants: zod_1.z
                    .record(zod_1.z.string(), zod_1.z.string())
                    .optional()
                    .nullable(),
            }),
            401: models_1.ZErrorResponseSchema,
        },
    },
    loginWithFacebook: {
        method: 'POST',
        path: '/login/facebook',
        body: zod_1.z.object({
            accessToken: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                token: zod_1.z.string(),
                welcomeName: zod_1.z.string(),
                abtestVariants: zod_1.z
                    .record(zod_1.z.string(), zod_1.z.string())
                    .optional()
                    .nullable(),
            }),
            401: models_1.ZErrorResponseSchema,
        },
    },
    loginWithApple: {
        method: 'POST',
        path: '/login/apple',
        body: zod_1.z.object({
            accessToken: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                token: zod_1.z.string(),
                welcomeName: zod_1.z.string(),
                abtestVariants: zod_1.z
                    .record(zod_1.z.string(), zod_1.z.string())
                    .optional()
                    .nullable(),
            }),
            401: models_1.ZErrorResponseSchema,
        },
    },
    verifyOperator: {
        method: 'GET',
        path: '/verifyoperator',
        responses: {
            200: zod_1.z.object({
                isOperator: zod_1.z.boolean(),
            }),
        },
        summary: 'Returns true if the player is an operator',
    },
    validateGoogleAccessToken: {
        method: 'POST',
        path: '/validate/google',
        body: zod_1.z.object({
            accessToken: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                token: zod_1.z.string(),
                welcomeName: zod_1.z.string(),
                abtestVariants: zod_1.z
                    .record(zod_1.z.string(), zod_1.z.string())
                    .optional()
                    .nullable(),
            }),
            201: zod_1.z.object({
                googleUserId: zod_1.z.string(),
            }),
            400: models_1.ZErrorResponseSchema,
        },
        summary: 'Register a player with Google access token',
    },
    validateFacebookAccessToken: {
        method: 'POST',
        path: '/validate/facebook',
        body: zod_1.z.object({
            accessToken: zod_1.z.string(),
            userId: zod_1.z.string(),
            email: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                token: zod_1.z.string(),
                welcomeName: zod_1.z.string(),
                abtestVariants: zod_1.z
                    .record(zod_1.z.string(), zod_1.z.string())
                    .optional()
                    .nullable(),
            }),
            201: zod_1.z.object({
                facebookUserId: zod_1.z.string(),
            }),
            400: models_1.ZErrorResponseSchema,
        },
        summary: 'Register a player with Facebook access token',
    },
    validateAppleAccessToken: {
        method: 'POST',
        path: '/validate/apple',
        body: zod_1.z.object({
            accessToken: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                token: zod_1.z.string(),
                welcomeName: zod_1.z.string(),
                abtestVariants: zod_1.z
                    .record(zod_1.z.string(), zod_1.z.string())
                    .optional()
                    .nullable(),
            }),
            201: zod_1.z.object({
                appleUserId: zod_1.z.string(),
                appleEmailAddress: zod_1.z.string(),
            }),
            400: models_1.ZErrorResponseSchema,
        },
        summary: 'Register a player with Apple access token',
    },
    getFacebookProfileFromCode: {
        method: 'POST',
        path: '/profile/facebook',
        body: zod_1.z.object({
            code: zod_1.z.string(),
            redirect_uri: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.object({
                accessToken: zod_1.z.string(),
                id: zod_1.z.string(),
                email: zod_1.z.string(),
                firstName: zod_1.z.string(),
                lastName: zod_1.z.string(),
            }),
            400: models_1.ZErrorResponseSchema,
        },
        summary: 'Retrieves Facebook profile information from a Facebook auth code',
    },
    country: {
        method: 'GET',
        path: '/country',
        responses: {
            200: zod_1.z.object({
                country: zod_1.z.string(),
            }),
        },
        summary: 'Returns a player object from the extracted JWT token',
    },
    currentTime: {
        method: 'GET',
        path: '/current-time',
        responses: {
            200: zod_1.z.object({
                now: zod_1.z.coerce.date(),
                reflectedHeaders: zod_1.z.string().optional(),
            }),
        },
        summary: 'Returns the current time, without any additional caching headers',
    },
    currentTimeCached: {
        method: 'GET',
        path: '/current-time-cached',
        responses: {
            200: zod_1.z.object({
                now: zod_1.z.coerce.date(),
            }),
        },
        summary: 'Returns the current time, with any additional caching headers to test Cloudfront distribution is behaving',
    },
    signUpForNewsletterWithDiscount: {
        method: 'POST',
        path: '/sign-up-for-newsletter-with-discount',
        body: zod_1.z.object({
            source: zod_1.z.string(),
            emailAddress: zod_1.z.string().email(),
            firstName: zod_1.z.string().optional(),
            utmParams: zod_1.z.record(zod_1.z.string()).nullable().optional(),
        }),
        responses: {
            200: utils_1.successSchema,
            400: models_1.ZErrorResponseSchema,
        },
        summary: 'Sign up for the newsletter with a discount code',
    },
}, {
    pathPrefix: '/public',
});
//# sourceMappingURL=auth.public.contract.js.map